import React from "react";
import styles from "./CenterBoxContent.scss";

export const CenterBoxContent = ({ children }) => {
    return <div className={styles.base}>{children}</div>;
};
